enum PreviewActionType {
	SET_PREVIEW_TYPE = "SET_PREVIEW_TYPE",
}

export default PreviewActionType

